import { useEffect, useRef } from 'react';

export function useObserveIntersection(onObserve: () => void) {
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const target = entries[0];
      if (target.isIntersecting) {
        onObserve();
      }
    });

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: The ref's value `.current` is accessed directly in the effect cleanup function.
      if (targetRef.current) {
        // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: The ref's value `.current` is accessed directly in the effect cleanup function.
        observer.unobserve(targetRef.current);
      }
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has an unnecessary dependency: targetRef.
  }, [onObserve, targetRef.current]);

  return targetRef;
}
